<template>

    <label> {{ props.text }}</label>
</template>

<script>
export default {
    name: "InputLabel"
}
</script>

<script setup>


let props = defineProps(["text"])


</script>

<style scoped>

</style>
